import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "../../services/baseQuery";
import { buildPagedListUrl } from "../../services/queryParams";

export const pageApi = createApi({
  reducerPath: "pageApi",
  baseQuery: appBaseQuery,
  tagTypes: ["Page"],
  endpoints: (builder) => ({
    getPages: builder.query({
      query: (params = {}) => buildPagedListUrl("page/", params),
      providesTags: ["Page"],
    }),
    addPage: builder.mutation({
      query: (newPage) => ({
        url: "page/",
        method: "POST",
        body: newPage,
      }),
      invalidatesTags: ["Page"],
    }),
    updatePage: builder.mutation({
      query: ({ uid, ...updatedPage }) => ({
        url: `page/${uid}`,
        method: "PUT",
        body: updatedPage,
      }),
      invalidatesTags: ["Page"],
    }),
    deletePage: builder.mutation({
      query: (uid) => ({
        url: `page/${uid}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Page"],
    }),
  }),
});

export const {
  useGetPagesQuery,
  useLazyGetPagesQuery,
  useAddPageMutation,
  useUpdatePageMutation,
  useDeletePageMutation,
} = pageApi;
